import { useMemo } from 'react'
import { find } from 'lodash-es'
import { useStiffeningStore } from '@editorStores'
import useElementLabel from './useElementLabel'
import useGuidToElementIncludingRips from './useGuidToElementIncludingRips'

const useElementPropertiesTreeInformation = (elementGuid: string | null) => {
  const getElementLabel = useElementLabel()
  const guidToElement = useGuidToElementIncludingRips()
  const stiffeningIntervals = useStiffeningStore(state => state.stiffeningIntervals)

  return useMemo(() => {
    if (!elementGuid) return null

    const stiffeningSegment = find(stiffeningIntervals, ['guid', elementGuid])
    let elementInfo: object | undefined
    if (stiffeningSegment) {
      elementInfo = stiffeningSegment
    } else if (guidToElement[elementGuid]) {
      elementInfo = guidToElement[elementGuid]
    } else {
      return null
    }

    return {
      label: getElementLabel(elementGuid),
      ...elementInfo,
    }
  }, [elementGuid, getElementLabel, guidToElement, stiffeningIntervals])
}

export default useElementPropertiesTreeInformation
